import { useSelector } from "react-redux";
import { useMemo, useCallback } from "react";
import { useActions } from "../../../hooks/useActions";
import {
    validateIfDocumentNumberExists,
    sendCrmOracleGetCustomer,
} from "../../../redux/home-insurance/home-insurance.actions";

export default function useDocumentNumberValidation(documentNumber, documentType) {
    const actions = useActions({
        validateIfDocumentNumberExists,
        sendCrmOracleGetCustomer,
    });
    const { documentNumberValidation } = useSelector(state => ({
        documentNumberValidation:
            state.HomeInsurance.quotation.initialQuotationForm.documentNumberValidation,
    }));
    const documentNumberCorrectLength = useMemo(() => (documentType === "DNI" ? 8 : -1), [
        documentType,
    ]);
    const handleDocumentNumberBlur = useCallback(() => {
        console.log(documentNumber)
        console.log(!!documentNumber)
        console.log(String(documentNumber).length)
        console.log(documentNumberCorrectLength)
        if (
            !!documentNumber &&
            String(documentNumber).length === documentNumberCorrectLength
        ) {
            console.log(documentNumber)
            console.log("se activan estos actiosn")
            actions.validateIfDocumentNumberExists({
                documentNumber: String(documentNumber),
                documentType,
            });

            actions.sendCrmOracleGetCustomer({
                documentNumber: String(documentNumber),
                documentType,
            });
        }
    }, [actions, documentNumber, documentNumberCorrectLength, documentType]);
    return {
        validating: documentNumberValidation.loading,
        exists: documentNumberValidation.exists,
        handleDocumentNumberBlur,
    };
}
